import { render, staticRenderFns } from "./BuildingSketch.vue?vue&type=template&id=311c8038&scoped=true&"
import script from "./BuildingSketch.vue?vue&type=script&lang=js&"
export * from "./BuildingSketch.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSketch.vue?vue&type=style&index=0&id=311c8038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c8038",
  null
  
)

export default component.exports